// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-694cd1f8] .el-dialog__body {\n  padding: 0.052083rem 0.104167rem 0.104167rem 0.104167rem;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 38>"],"names":[],"mappings":"AAAA;EACE,wDAAwD;AAC1D","file":"breathResponse.vue","sourcesContent":["/deep/.el-dialog__body {\n  padding: 0.052083rem 0.104167rem 0.104167rem 0.104167rem;\n}"]}]);
// Exports
module.exports = exports;
